import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import { setGraphFilters, updateGraphFilter, updateGraphFilters } from 'Actions/graphFilter';
import { getGraphs } from 'Services/GraphFilterUtils';
import withFilterData from './withFilterData';
import { GRAPH } from 'Types';
import FilterBody from './FilterBody';
import FilterHeader from './FilterHeader';
import GraphFilterItem from './GraphFilterItem';
import tabStyles from './tabStyles';

const graphFilterSelector = createSelector(
  (state) => state.graphFilter.graphFilters,
  _.values
);

const GraphFilterGraphs = ({ items }) => {
  const dispatch = useDispatch();
  const graphFilters = useSelector(graphFilterSelector);

  const [filterValue, setFilterValue] = useState("");

  useEffect(() => {
    const sorted = _.sortBy(items, [(item) => item.label.toLowerCase()])
    dispatch(setGraphFilters(_.keyBy(sorted, 'id')));
  }, [items]);

  const CellRenderItem = ({ item, ...props }) => {
    const itemProps = {
      itemType: GRAPH,
      enabled: item.enabled,
      value: item.id,
      label: item.label,
      enableByDefault: true,
      ...props
    };

    return <GraphFilterItem {...itemProps} />;
  };

  return (
    <div style={tabStyles}>
      <FilterHeader
        updateFilters={updateGraphFilters}
        items={graphFilters}
        idField="id"
        onFilter={setFilterValue}
      />
      <FilterBody
        items={graphFilters}
        idField="id"
        filterValue={filterValue}
        updateFilter={updateGraphFilter}
        CellRenderItem={CellRenderItem}
      />
    </div>
  );
};

export default withFilterData(GraphFilterGraphs, getGraphs, graphFilterSelector);
